import { render } from "./UniversityView.vue?vue&type=template&id=d020da70"
import script from "./UniversityView.vue?vue&type=script&lang=js"
export * from "./UniversityView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__